/** Emotion/MUI styles for Help Center SSR (replaces Help.css modules). */

export const helpHomePageLayoutSx = {
  background:
    'linear-gradient(rgba(92, 192, 145, 0.9), rgba(35, 181, 195, 0.5) 100px, rgba(35, 181, 195, 0) 230px), #fafaf9',
  backgroundSize: 'cover',
};

export const helpMainSx = {
  flex: '1 0 auto',
  maxWidth: 1280,
  alignSelf: 'center',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minHeight: '80vh',
  '& a': {
    textDecoration: 'none',
  },
};

export const helpContentHomeSx = {
  py: 3,
  px: '1em',
  bgcolor: '#fafaf9',
  flex: '1 0 auto',
  margin: '0 auto',
};

export const helpContentSx = {
  py: 3,
  px: '1em',
  bgcolor: '#fafaf9',
  flex: '1 0 auto',
};

export const helpGridSx = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: '1fr 1fr 1fr' },
  alignItems: 'center',
  justifyContent: 'center',
  gap: 3,
  margin: 'auto',
};

export const helpCardSx = {
  width: '100%',
  maxWidth: 300,
  textAlign: 'center',
  justifySelf: 'center',
  '& .MuiCardMedia-root': {
    pt: 3,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  '& .MuiCardContent-root': {
    minHeight: 150,
  },
};

export const helpIconSx = {
  strokeWidth: '1px',
  stroke: 'currentColor',
  fill: 'none',
};

export const helpPaperSx = {
  p: 6,
};

export const helpLeftNavSx = {
  p: 0,
  m: 0,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flex: 1,
  mx: '1em',
  '& ul': {
    p: 0,
    m: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    listStyle: 'none',
    '& > li': {
      display: 'inline-block',
      m: 0,
      p: 0,
      listStyleType: 'none',
      '& a': {
        maxWidth: 150,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        color: 'rgba(0,0,0,0.54)',
        textDecoration: 'none',
        '&:visited': {
          color: 'rgba(0,0,0,0.54)',
          textDecoration: 'none',
        },
        '&:hover': {
          color: 'rgba(0,0,0,0.65)',
          textDecoration: 'none',
        },
      },
      '&::before': {
        content: '"/"',
        color: 'rgba(0,0,0,0.3)',
        pr: '10px',
        pl: '10px',
      },
      '&:first-of-type::before': {
        content: '""',
        pr: 0,
        pl: 0,
      },
    },
  },
};

export const helpHeaderSectionSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  py: 3,
};

export const helpTitleSx = {
  alignSelf: 'center',
};

export const helpSearchContainerSx = {
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
};

export const helpSearchInputSx = {
  width: '100%',
  bgcolor: 'white',
};

export const helpSearchBoxContainerSx = {
  position: 'relative',
  width: '100%',
  maxWidth: 300,
  margin: '0 auto',
};

export const helpSearchBoxContainerHomeSx = {
  position: 'relative',
  width: '100%',
  maxWidth: 600,
};

export const helpSearchResultsSx = {
  mb: 4,
  p: 3,
  borderRadius: 1,
};

export const helpSearchResultsTitleSx = {
  mb: 2,
  fontWeight: 600,
};

export const helpSearchResultItemSx = {
  mb: 2,
  p: 2,
  bgcolor: 'white',
  borderRadius: 0.5,
  border: '1px solid rgba(0, 0, 0, 0.12)',
  transition: 'box-shadow 0.2s ease',
  '&:hover': {
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  },
  '&:last-child': {
    mb: 0,
  },
};

export const helpSearchResultLinkSx = {
  textDecoration: 'none',
  color: 'inherit',
  display: 'block',
};

export const helpSearchResultTitleSx = {
  fontWeight: 600,
  mb: 1,
};

export const helpSearchResultExcerptSx = {
  overflow: 'hidden',
  color: 'rgba(0, 0, 0, 0.7)',
  lineHeight: 1.4,
  mt: 0.5,
  '& mark': {
    bgcolor: '#fff3cd',
    color: '#856404',
    px: '1px',
    py: '1px',
    borderRadius: '2px',
    fontWeight: 600,
  },
  '& li::marker': {
    content: 'none',
  },
  '& p': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

export const helpSearchResultsDropdownSx = {
  position: 'absolute',
  textAlign: 'left',
  top: '100%',
  left: 0,
  right: 0,
  bgcolor: 'white',
  border: '1px solid rgba(0, 0, 0, 0.12)',
  borderRadius: 0.5,
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  zIndex: 1000,
  maxHeight: 400,
  overflowY: 'auto',
  mt: 0.5,
  '& .help-search-dropdown-title': {
    p: '12px 16px 8px',
    fontWeight: 600,
    fontSize: 14,
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  '& .help-search-dropdown-link': {
    display: 'block',
    p: '12px 16px',
    textDecoration: 'none',
    color: 'inherit',
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
    transition: 'background-color 0.2s ease',
    overflow: 'hidden',
    '&:hover': {
      bgcolor: '#f5f5f5',
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  '& .help-search-dropdown-result-title': {
    fontWeight: 600,
    fontSize: 14,
    mb: 0.5,
  },
  '& .help-search-dropdown-excerpt': {
    color: 'rgba(0, 0, 0, 0.7)',
    fontSize: 11,
    lineHeight: 1.3,
    mt: 0.25,
    '& mark': {
      bgcolor: '#fff3cd',
      color: '#856404',
      px: '1px',
      py: '1px',
      borderRadius: '2px',
      fontWeight: 600,
    },
  },
};
